import React from 'react';
import { mockJobs } from '../data/mockData';
import { Cpu, CheckCircle, AlertCircle, RefreshCw, Terminal } from 'lucide-react';
export const ProcessingScreen: React.FC = () => {
  return <div className="max-w-6xl mx-auto" data-id="element-499">
      <div className="flex justify-between items-end mb-6" data-id="element-500">
        <div data-id="element-501">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-502">
            Middleware Processing
          </h1>
          <p className="text-slate-500" data-id="element-503">
            Monitor data conversion, sanitization, and mapping
          </p>
        </div>
        <button className="btn-secondary flex items-center text-sm" data-id="element-504">
          <RefreshCw size={16} className="mr-2" data-id="element-505" /> Refresh Status
        </button>
      </div>

      {/* Pipeline Visualization */}
      <div className="card p-6 mb-8 bg-slate-900 text-white" data-id="element-506">
        <h2 className="text-sm font-semibold text-slate-300 mb-6 uppercase tracking-wider flex items-center" data-id="element-507">
          <Cpu size={18} className="mr-2" data-id="element-508" /> Processing Pipeline
        </h2>
        <div className="flex justify-between items-center relative" data-id="element-509">
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-full h-0.5 bg-slate-700 -z-10" data-id="element-510"></div>

          {[{
          name: 'Ingestion',
          status: 'done'
        }, {
          name: 'Unicode Conversion',
          status: 'active'
        }, {
          name: 'Sanitization',
          status: 'pending'
        }, {
          name: 'Schema Mapping',
          status: 'pending'
        }, {
          name: 'Cross-check',
          status: 'pending'
        }].map((step, i) => <div key={i} className="flex flex-col items-center bg-slate-900 px-2" data-id="element-511">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 mb-2
                ${step.status === 'done' ? 'bg-teal-900 border-teal-500 text-teal-400' : step.status === 'active' ? 'bg-blue-900 border-blue-500 text-blue-400 animate-pulse' : 'bg-slate-800 border-slate-600 text-slate-500'}`} data-id="element-512">
                {step.status === 'done' ? <CheckCircle size={20} data-id="element-513" /> : step.status === 'active' ? <RefreshCw size={20} className="animate-spin" data-id="element-514" /> : <span className="text-sm font-bold" data-id="element-515">{i + 1}</span>}
              </div>
              <span className={`text-xs font-medium ${step.status === 'active' ? 'text-blue-400' : 'text-slate-400'}`} data-id="element-516">
                {step.name}
              </span>
            </div>)}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-517">
        {/* Jobs List */}
        <div className="lg:col-span-1 space-y-4" data-id="element-518">
          <h2 className="font-semibold text-slate-800" data-id="element-519">Active Jobs</h2>
          {mockJobs.map(job => <div key={job.id} className={`card p-4 border-l-4 ${job.status === 'processing' ? 'border-l-blue-500' : job.status === 'completed' ? 'border-l-teal-500' : 'border-l-red-500'}`} data-id="element-520">
              <div className="flex justify-between items-start mb-2" data-id="element-521">
                <div data-id="element-522">
                  <span className="text-xs font-bold text-slate-500" data-id="element-523">
                    {job.id}
                  </span>
                  <h3 className="font-medium text-slate-900 text-sm" data-id="element-524">
                    {job.mouja}
                  </h3>
                </div>
                {job.status === 'processing' && <span className="flex h-3 w-3 relative" data-id="element-525">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" data-id="element-526"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500" data-id="element-527"></span>
                  </span>}
                {job.status === 'completed' && <CheckCircle size={16} className="text-teal-500" data-id="element-528" />}
                {job.status === 'error' && <AlertCircle size={16} className="text-red-500" data-id="element-529" />}
              </div>
              <p className="text-xs text-slate-600 mb-3" data-id="element-530">Step: {job.step}</p>
              <div className="w-full bg-slate-200 rounded-full h-1.5" data-id="element-531">
                <div className={`h-1.5 rounded-full ${job.status === 'error' ? 'bg-red-500' : job.status === 'completed' ? 'bg-teal-500' : 'bg-blue-500'}`} style={{
              width: `${job.progress}%`
            }} data-id="element-532"></div>
              </div>
            </div>)}
        </div>

        {/* Terminal / Logs */}
        <div className="lg:col-span-2 card bg-slate-900 text-slate-300 font-mono text-sm overflow-hidden flex flex-col h-[500px]" data-id="element-533">
          <div className="bg-slate-950 px-4 py-2 border-b border-slate-800 flex items-center justify-between" data-id="element-534">
            <div className="flex items-center" data-id="element-535">
              <Terminal size={16} className="mr-2 text-slate-500" data-id="element-536" />
              <span className="text-xs text-slate-400" data-id="element-537">
                System Logs - JOB-9921 (Ershad Nagar)
              </span>
            </div>
            <div className="flex space-x-1.5" data-id="element-538">
              <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-539"></div>
              <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-540"></div>
              <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-541"></div>
            </div>
          </div>
          <div className="p-4 overflow-y-auto flex-1 space-y-2" data-id="element-542">
            {mockJobs[0].logs.map((log, i) => <div key={i} className="flex" data-id="element-543">
                <span className="text-slate-600 mr-4" data-id="element-544">
                  [{new Date().toISOString().split('T')[1].substring(0, 8)}]
                </span>
                <span className={log.includes('[ERROR]') ? 'text-red-400' : log.includes('[SUCCESS]') ? 'text-teal-400' : 'text-slate-300'} data-id="element-545">
                  {log}
                </span>
              </div>)}
            <div className="flex animate-pulse" data-id="element-546">
              <span className="text-slate-600 mr-4" data-id="element-547">
                [{new Date().toISOString().split('T')[1].substring(0, 8)}]
              </span>
              <span className="text-blue-400" data-id="element-548">
                Processing record 452/840...
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};